"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.confirmed.title': '¡Pago Exitoso!',
    'payment.confirmed.message': 'Gracias por su pago. Su transacción se ha completado exitosamente.',
    'payment.confirmed.details': 'Detalles del Pago',
    'payment.confirmed.date': 'Fecha de Pago',
    'payment.confirmed.paymentIntent': 'ID de Intención de Pago',
    'payment.confirmed.fetchError': 'No se pueden obtener los detalles del pago',
    'payment.confirmed.unknownProvider': 'Proveedor Desconocido',
    'payment.confirmed.accountUpgraded': 'Cuenta Actualizada Exitosamente',
    'payment.confirmed.accountUpgradedMessage': 'Su cuenta ha sido actualizada y las nuevas funciones ya están disponibles.',
    'payment.confirmed.nextSteps': '¿Qué sigue?',
    'payment.confirmed.nextStepsMessage': 'Ahora puede comenzar a usar sus funciones mejoradas. Explore el chat de IA, cree avatares y administre su base de conocimientos.',
    'payment.confirmed.startChatting': 'Comenzar a Chatear',
    'payment.confirmed.viewAccount': 'Ver Cuenta',
    'payment.confirmed.backHome': 'Volver al Inicio',
    'payment.confirmed.receiptInfo': 'Se ha enviado un recibo a su dirección de correo electrónico. También puede descargarlo desde la configuración de su cuenta.',
};
